import { memo, useMemo, CSSProperties } from 'react';
import { GridHeaderRow } from '../../../../../../api/generated/data-contracts';
import { VirtualItem } from '@tanstack/react-virtual';
import { GridHeader } from './Headers/GridHeader';
import { TableHeader } from './Headers/TableHeader';
import { BORDER, COLUMN_WIDTH, ROOT_ROW_BG, TOP_HEADERS_HEIGHT } from '../CONSTANTS';

export const HeaderContainer = memo(function HeaderContainer({
    start,
    totalWidth,
    headers,
    columns,
}: {
    start: number;
    columns: VirtualItem[];
    totalWidth: number;
    headers: GridHeaderRow[];
}) {
    const style = useMemo(() => {
        return {
            position: 'sticky',
            transform: `translateY(${start}px)`,
            top: 0,
            left: 0,
            height: `${TOP_HEADERS_HEIGHT}px`,
            borderBottom: BORDER,
            width: `${totalWidth}px`,
            boxSizing: 'border-box',
            background: ROOT_ROW_BG,
            zIndex: 2,
        } as CSSProperties;
    }, [start, totalWidth]);
	
    const render = useMemo(() => {
        return columns.map(({ start, key, index }) => {
            if (index === 0) {
                return <GridHeader key={String(key)} />;
            }
			const columnIndex = index - 1;
            const header = headers[columnIndex];
			if (!header) {
				return null;
			}
            return <Header key={String(key)} header={header} start={start} index={columnIndex} />;
        });
    }, [columns, headers]);
    return <div style={style}>{render}</div>;
});

const Header = ({ header: { name }, index, start }: { header: GridHeaderRow; index: number; start: number; }) => {
    const style = useMemo(() => {
        return {
            width: `${COLUMN_WIDTH}px`,
            borderBottom: BORDER,
            borderRight: BORDER,
            zIndex: 1,
            position: 'absolute',
            transform: `translateX(${start}px)`,
            top: 0,
            left: 0,
            height: `${TOP_HEADERS_HEIGHT}px`,
            boxSizing: 'border-box',
        } as CSSProperties;
    }, [start]);
    return (
        <div style={style}>
            <TableHeader index={index}>
                {name}
            </TableHeader>
        </div>
    );
};